const initialState = {
  pieChartData: [],
};
const sectionWiseUnitCountState = {
  sectionWiseUnitData: [],
};
const sectionWiseUnitState = {
  sectionUnitData: [],
};
const allProjectsState = {
  allProjectsData: [],
};
export const inventoryPieChartRed = (state = initialState, action) => {
  switch (action.type) {
    case "set_pie_chart_data":
      return {
        ...state,
        pieChartData: action.payload,
      };
    default:
      return state;
  }
};

export const invSectionUnitRed = (state = sectionWiseUnitCountState, action) => {
  switch (action.type) {
    case "set_sectionwise_unitcount_data":
      return {
        ...state,
        sectionUnitData: action.payload,
      };
    default:
      return state;
  }
};
export const invSectionWiseUnitRed = (state = sectionWiseUnitState, action) => {
  switch (action.type) {
    case "set_sectionwise_unit_data":
      return {
        ...state,
        sectionWiseUnitData: action.payload,
      };
    default:
      return state;
  }
};
export const invAllProjectsRed = (state = allProjectsState, action) => {
  switch (action.type) {
    case "set_AllProjects_data":
      return {
        ...state,
        allProjectsData: action.payload,
      };
    default:
      return state;
  }
};
